import { render, staticRenderFns } from "./login2_pc.vue?vue&type=template&id=a6dd4016&scoped=true"
import script from "./login2_pc.vue?vue&type=script&lang=js"
export * from "./login2_pc.vue?vue&type=script&lang=js"
import style0 from "./login2_pc.vue?vue&type=style&index=0&id=a6dd4016&prod&lang=less&scoped=true"
import style1 from "./login2_pc.vue?vue&type=style&index=1&id=a6dd4016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dd4016",
  null
  
)

export default component.exports